/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { IdDumpDto } from '../models/IdDumpDto';
import type { ScheduledValidatorIdDumpDto } from '../models/ScheduledValidatorIdDumpDto';
import type { ValidatorIdDumpScheduleDto } from '../models/ValidatorIdDumpScheduleDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ValidatorIdDumpsControllerService {

    /**
     * @param validatorName
     * @returns ScheduledValidatorIdDumpDto OK
     * @throws ApiError
     */
    public static getSchedule(
        validatorName: string,
    ): CancelablePromise<ScheduledValidatorIdDumpDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/id-dumps/{validatorName}/schedule',
            path: {
                'validatorName': validatorName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param validatorName
     * @param requestBody
     * @returns ScheduledValidatorIdDumpDto OK
     * @throws ApiError
     */
    public static updateSchedule(
        validatorName: string,
        requestBody: ValidatorIdDumpScheduleDto,
    ): CancelablePromise<ScheduledValidatorIdDumpDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/id-dumps/{validatorName}/schedule',
            path: {
                'validatorName': validatorName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param validatorName
     * @param requestBody
     * @returns ScheduledValidatorIdDumpDto Created
     * @throws ApiError
     */
    public static createSchedule(
        validatorName: string,
        requestBody: ValidatorIdDumpScheduleDto,
    ): CancelablePromise<ScheduledValidatorIdDumpDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/id-dumps/{validatorName}/schedule',
            path: {
                'validatorName': validatorName,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param validatorName
     * @returns void
     * @throws ApiError
     */
    public static deleteSchedule(
        validatorName: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/id-dumps/{validatorName}/schedule',
            path: {
                'validatorName': validatorName,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param validatorName
     * @returns IdDumpDto OK
     * @throws ApiError
     */
    public static listParticipantIdentityDumps(
        validatorName: string,
    ): CancelablePromise<Array<IdDumpDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/id-dumps/{validatorName}',
            path: {
                'validatorName': validatorName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param validatorName
     * @returns IdDumpDto OK
     * @throws ApiError
     */
    public static createIdentityDump(
        validatorName: string,
    ): CancelablePromise<IdDumpDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/id-dumps/{validatorName}',
            path: {
                'validatorName': validatorName,
            },
            errors: {
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @returns IdDumpDto OK
     * @throws ApiError
     */
    public static listAllParticipantIdentityDumps(): CancelablePromise<Array<IdDumpDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/id-dumps',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param validatorName
     * @returns void
     * @throws ApiError
     */
    public static deleteAllIdentityDumps(
        validatorName: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/id-dumps/{validatorName}/dumps',
            path: {
                'validatorName': validatorName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

    /**
     * @param validatorName
     * @param secretName
     * @returns void
     * @throws ApiError
     */
    public static deleteIdentityDump(
        validatorName: string,
        secretName: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/id-dumps/{validatorName}/dumps/{secretName}',
            path: {
                'validatorName': validatorName,
                'secretName': secretName,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }

}
